export const formatModuleTree = (arr) => {
  if (arr && arr.length) {
    return arr.map((item, index) => ({
      isActive: false,
      ...arr[index],
    }));
  } else {
    return []
  }
};

export const orderRules = [
  {
    id: 0,
    name: "不限",
    isActive: true,
  },
  {
    id: 'createTime',
    name: "发布时间",
    isActive: false,
  },
  {
    id: 'valueScore',
    name: "价值度",
    isActive: false,
  },
  {
    id: 'viewCount',
    name: "阅读量",
    isActive: false,
  },
];
export const isLogin = () => {
  return localStorage.getItem("token") ? true : false;
};

export const  calculateTimeDifference = (targetTime) => {
  // 将目标时间字符串转换为 Date 对象
  const targetDate = new Date(targetTime);

  // 获取当前时间
  const now = new Date();

  // 计算时间差（以毫秒为单位）
  const difference = targetDate - now;

  // 如果时间差为负数，表示目标时间已经过去
  if (difference < 0) {
    return '会议已经开始';
  }

  // 计算天、小时、分钟和秒
  let days = Math.floor(difference / (1000 * 60 * 60 * 24));
  let hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  let seconds = Math.floor((difference % (1000 * 60)) / 1000);
  function format2(number) {
    return number < 10 ? '0' + number : number;
  }
  days = format2(days);
  hours = format2(hours);
  minutes = format2(minutes);
  seconds = format2(seconds);
  // 返回结果
  return {
    days,
    hours,
    minutes,
    seconds
  };
}
// target: 'http://api.changank.com',

export const baseURL = 'https://api.changank.com';
// export const baseURL = 'http://192.168.137.161:9502';

export const uploadUrl = baseURL + '/common/upload/';